import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPeepRelatedLeads as GetPeepRelatedLeadsQuery,
    PeepRelatedLeadFragment as Lead,
    GetPeepRelatedLeads_peep as Peep,
    GetPeepRelatedLeadsVariables as GetPeepRelatedLeadsQueryVariables,
    PeepRelatedLeadStatsFragment,
} from 'nutshell-graphql-types';

import GET_PEEP_RELATED_LEADS from '../../graphql/queries/get-peep-related-leads.graphql';

export const useGetPeepRelatedLeads = (
    peepId: string
): {
    peep: Peep | undefined;
    leads: Lead[] | undefined;
    stats: PeepRelatedLeadStatsFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetPeepRelatedLeadsQuery, GetPeepRelatedLeadsQueryVariables>(
        GET_PEEP_RELATED_LEADS,
        {
            variables: {id: peepId},
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        peep: data?.peep,
        leads: data?.peep?.leads?.edges?.map((edge) => edge.node),
        stats: data?.peep?.leads?.stats,
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
